import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=22bb7a6d&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=ts&"
export * from "./Voucher.vue?vue&type=script&lang=ts&"
import style0 from "./Voucher.vue?vue&type=style&index=0&media=print&lang=css&"
import style1 from "./Voucher.vue?vue&type=style&index=1&id=22bb7a6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bb7a6d",
  null
  
)

export default component.exports